import { withSvgIcon } from './withSvgIcon';

export const NavBarSettings = withSvgIcon(
  <>
    <path
      d="M12 3L20 7V17L12 21L4 17V7L12 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M9 12H15" stroke="currentColor" strokeWidth="1.5" />
    <path d="M12 15V9" stroke="currentColor" strokeWidth="1.5" />
  </>,
  { viewBox: '0 0 24 24' },
);
